/**
 * Forwards every query parameter from the current page's URL onto an
 * outbound sign-up link. A visitor can land on the login page with partner
 * tracking params (im_ref, irpid, irgwc, afsrc, aff, etc.) in the URL and
 * click "Sign up" before ever reaching /registration — without this, that
 * link is a plain SignUpUrl/PortalUrl href with no query forwarding, so all
 * of that context would be dropped. Mirrors withInsiderPlusOutboundContext's
 * approach of re-appending context onto the outbound URL so the destination
 * (Registration/RegistrationPageOne) still sees it and can send it on to
 * tracking-details.
 */
export const withOutboundQueryParams = (url) => {
  if (!url || typeof window === 'undefined') return url;

  const currentParams = new URLSearchParams(window.location.search);
  if ([...currentParams.keys()].length === 0) return url;

  try {
    const target = new URL(url, window.location.origin);
    currentParams.forEach((value, key) => {
      target.searchParams.set(key, value);
    });
    return target.toString();
  } catch {
    return url;
  }
};
